import { useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { useRinnovi } from "../../hooks/useFase2";
import { MobileShell } from "../shell/MobileShell";
import { StagioneSelector } from "../common/StagioneSelector";
import { SquadraSelector } from "../common/SquadraSelector";
import { localeCorrente } from "../../i18n";
import { tr } from "../../i18n";

const DECISIONE_COLOR: Record<string, string> = {
  rinnova: "bg-success/20 text-success",
  non_rinnova: "bg-danger/20 text-danger",
};

export function RinnoviPage() {
  useAuth(); // session check
  const [stagioneId, setStagioneId] = useState<string>("");
  const [squadraId, setSquadraId] = useState<string>("");
  const { data, isLoading } = useRinnovi(stagioneId || null, squadraId || null);

  const pendenti = data?.filter((r) => r.decisione_presidente === null).length ?? 0;
  const rinnovati = data?.filter((r) => r.decisione_presidente === "rinnova").length ?? 0;
  const nonRinnovati = data?.filter((r) => r.decisione_presidente === "non_rinnova").length ?? 0;

  return (
    <MobileShell logoSuffix="RINNOVI">
      <h2 className="font-display text-3xl text-accent tracking-wide">{tr("Rinnovi rosa")}</h2>

      <div className="card grid grid-cols-1 md:grid-cols-2 gap-3">
        <StagioneSelector value={stagioneId} onChange={setStagioneId} />
        <SquadraSelector value={squadraId} onChange={setSquadraId} />
      </div>

      {isLoading && stagioneId && squadraId && (
        <div className="card text-fg-muted">{tr("Caricamento…")}</div>
      )}

      {data && (
        <>
          <div className="grid grid-cols-3 gap-3">
            <div className="card text-center">
              <div className="text-xs text-fg-muted uppercase tracking-wider">{tr("Pendenti")}</div>
              <div className="font-display text-3xl text-warning mt-1">{pendenti}</div>
            </div>
            <div className="card text-center">
              <div className="text-xs text-fg-muted uppercase tracking-wider">
                {tr("Rinnovati")}
              </div>
              <div className="font-display text-3xl text-success mt-1">{rinnovati}</div>
            </div>
            <div className="card text-center">
              <div className="text-xs text-fg-muted uppercase tracking-wider">
                {tr("Non rinnovati")}
              </div>
              <div className="font-display text-3xl text-danger mt-1">{nonRinnovati}</div>
            </div>
          </div>

          <div className="card p-0 overflow-hidden">
            {data.length === 0 && (
              <div className="p-6 text-center text-fg-muted">
                {tr("Nessun rinnovo per questa squadra/stagione.")}
              </div>
            )}
            {data.map((r) => (
              <div
                key={r.id}
                className="flex items-center gap-4 p-4 border-b border-primary/10 last:border-b-0"
              >
                <div className="flex-1 min-w-0">
                  <div className="font-mono text-sm text-fg-muted">
                    giocatore: {r.giocatore_id.slice(0, 8)}…
                  </div>
                  <div className="text-xs text-fg-muted mt-1">
                    valore_tm {Number(r.valore_tm_riferimento_milioni).toFixed(2)}M · costo{" "}
                    {r.costo_rinnovo_milioni}M{r.esente && tr(" · ESENTE")}
                    {r.data_rinnovo &&
                      ` · ${new Date(r.data_rinnovo).toLocaleDateString(localeCorrente())}`}
                  </div>
                </div>
                <span
                  className={`pill ${
                    r.decisione_presidente
                      ? DECISIONE_COLOR[r.decisione_presidente]
                      : "bg-warning/20 text-warning"
                  }`}
                >
                  {r.decisione_presidente ?? "pendente"}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </MobileShell>
  );
}
